// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ieINXdmWz3dhFh1LypIw {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eee;
  border-radius: 4px;
  padding: 2px;
  cursor: pointer;
}
.BxHn71d0LRgYNxrpus9N {
  max-width: 46px;
  max-height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lbdWzaZ0f0eSN2XusR1C {
  height: 100%;
  overflow-y: scroll;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/LeftPanel/node.module.less"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAAF;AAGA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADF;AAIA;EACE,YAAA;EACA,kBAAA;AAFF","sourcesContent":["\n.nodeContainer {\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #eee;\n  border-radius: 4px;\n  padding: 2px;\n  cursor: pointer;\n}\n\n.nodeImg {\n  max-width: 46px;\n  max-height: 46px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.container {\n  height: 100%;\n  overflow-y: scroll;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nodeContainer": `ieINXdmWz3dhFh1LypIw`,
	"nodeImg": `BxHn71d0LRgYNxrpus9N`,
	"container": `lbdWzaZ0f0eSN2XusR1C`
};
export default ___CSS_LOADER_EXPORT___;
